import { render } from "./FFooter.vue?vue&type=template&id=0a5adfa6"
import script from "./FFooter.vue?vue&type=script&lang=js"
export * from "./FFooter.vue?vue&type=script&lang=js"

import "./FFooter.vue?vue&type=style&index=0&id=0a5adfa6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__